// extracted by mini-css-extract-plugin
export default {"text":"app-lists-ListRemoveModal-ListRemoveModal-module__QiSG4COL_f3B7uxff8Av"};